import { css, jsx } from '@emotion/react';
import { labelStyles } from '@zapier/style-encapsulation';
import { Alert } from '@zapier/design-system';
import { boxSizing } from '../../../../utils/style-mixins/reset';
const Styles = labelStyles('BannerMessage', {
    content: css `
    ${boxSizing};
    display: inline-block;

    // Reset styles lifted from @zapier/style-encapsulation package.
    * {
      all: unset;
      box-sizing: border-box;
      -webkit-text-fill-color: currentColor;
    }
    strong {
      font-weight: 700;
    }
    em {
      font-style: italic;
    }
    a {
      cursor: pointer;
      text-decoration: underline;
    }
  `,
});
export const shouldRender = (data) => {
    return !!data.currentUser.bannerMessage;
};
export const Component = function BannerMessage(props) {
    const content = (jsx("div", { css: Styles.content, dangerouslySetInnerHTML: {
            __html: props.data.currentUser.bannerMessage,
        }, "data-zds": true }));
    return (jsx(Alert, { "aria-live": "polite", variant: props.variant, title: content, status: "info" }));
};
//# sourceMappingURL=BannerMessage.js.map
// @zapier/universal-layout@12.0.37 (fb08e5a7f)
